import { Button, Dialog, DialogProps, Stack, Typography, Divider, Box } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { IAddColumnDialogProps } from '../../../types';

const AddColumnDialog: FunctionComponent<
  PropsWithChildren<
    IAddColumnDialogProps &
      Omit<DialogProps, 'onSubmit'> & {
        isEdit: boolean;
        disabled?: boolean;
        columnStatistics?: Record<string, boolean>;
      }
  >
> = ({ isEdit, children, disabled = false, onSubmit, onCancel, ...props }) => (
  <Dialog
    {...props}
    sx={{
      '& .MuiPaper-root': {
        width: '800px',
        overflowX: 'hidden',
        maxWidth: '100%',
        boxSizing: 'border-box',
        background: '#ffffff',
        maxHeight: '90vh',
      },
    }}
  >
    <Typography padding="24px" variant="h6">
      {isEdit ? 'Edit column' : 'Add column'}
    </Typography>
    <Divider />

    <Box
      sx={{
        maxHeight: 'calc(90vh - 160px)',
        overflowY: 'auto',
        paddingInline: '0px',
      }}
    >
      {children}
    </Box>

    <Stack flexDirection="row" justifyContent="flex-end" sx={{ padding: '24px' }}>
      <Stack flexDirection="row" gap="10px">
        <Button onClick={onCancel} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button
          disabled={disabled}
          onClick={() => onSubmit()}
          variant="contained"
          color="primary"
          data-sm="done-btn"
        >
          Done
        </Button>
      </Stack>
    </Stack>
  </Dialog>
);
export default AddColumnDialog;
